    import React, { useState } from "react";
    import '../components/styles.css'
    import { Link, useNavigate } from "react-router-dom";
    import setCookie from "../setCookie";
    import { ColorRing } from "react-loader-spinner";

    export default function Signup(){
        
        const [email, setEmail] = useState("");
        const [password, setPassword] = useState("");
        const [repassword, setRepassword] = useState("");
        const [loading, setLoading] = useState(false); 
        const navigate = useNavigate();
        
        const signupUser = async (event) => {
           event.preventDefault();
           setLoading(true);
           document.getElementById('signup').disabled = true;
           try{
                const baseURL = process.env.REACT_APP_BASEURL;
                const url  = baseURL + "signup";
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ email, password, repassword }),
                });
                
                if (response.ok) {
                    const data = await response.json();
                    setCookie("auth-cookie", data.token);
                    setTimeout(() => {
                        setLoading(false);
                        navigate("/dashboard");}, 2000);
                } else {
                    const data = await response.json();
                    alert(data.detail); // Display any error message from the backend
                    document.getElementById('signup').disabled = false;
                }
            } catch (error) {
                console.log("Error printed from catch block");
                alert(error.message);
                document.getElementById('signup').disabled = false;
            }
        };

        return(
            <div className = "form-container">
            <form id = "signup-form"  className = "form-card">
                    <p className="form-header">Signup</p>
                    <input className = "form-input" onChange={(e)=>setEmail(e.target.value)} type="email" placeholder="Enter your email address" required></input>
                    <input className = "form-input" onChange={(e)=>setPassword(e.target.value)} type="password" placeholder="Enter a password" required></input>
                    <input className = "form-input" onChange={(e)=>setRepassword(e.target.value)} type="password" placeholder="Confirm your password" required></input>
                    <button id = 'signup' className = "form-submit-button" onClick ={signupUser}>Signup</button>
                    {loading && (
                                <ColorRing
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="blocks-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="blocks-wrapper"
                                    colors={[
                                    "#e15b64",
                                    "#f47e60",
                                    "#f8b26a",
                                    "#abbd81",
                                    "#849b87",
                                    ]}
                                />
                    )}
                    
                    <div className ='form-redirect-section'>
                        <p className="para-text">Already have an account?</p>
                        <Link className="formLink" to = "/login">Login</Link>
                    </div>
            </form>
            </div>
            
        
        )
    }